import { useContext, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { dataContext } from "../../context/context";
import './header.css';
import logo from "../../assets/images/logo-wide.svg";

function HeaderMobile() {

    const { data  } = useContext(dataContext);
    const [ isMenuOpened, setMenuOpened ] = useState(false);


    return (

        <>
            <motion.header

                initial={{ opacity: 0, y: -100, }}
                animate={{ opacity: 1, y: 0  }}
                transition={{ duration: 1 }}

            >
                <div className="header__inner">

                    <button className="icon" onClick={() => setMenuOpened(!isMenuOpened)}>&#61641;</button>
                    <div className="logo"><a href="/"><img alt="студия Феникс - разработка сйтов и мобильных приложений в Калининграде" src={logo} /></a></div>

                    {
                        data.variablesdata.filter(variable => variable.var === 'phone').slice(0, 1).map((phone, index) => (
                        <a key={index} className="icon iconbig" href={`tel: ${phone.clearedval}`}>&#61707;</a>
                        ))
                    }


                </div>
            </motion.header>

            <AnimatePresence>
            { isMenuOpened && (
                <motion.div key="100" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }} exit={{ opacity: 0 }} className="background_modal" onClick={() => setMenuOpened(false)}></motion.div>
            )}
            </AnimatePresence>

            <AnimatePresence>
                { isMenuOpened && (
            <motion.div initial={{ x: "-100%" }} animate={{ x: "0%" }} transition={{ duration: 0.25 }} exit={{ x: "-100%" }} className="menu__mobile">
                <button className="icon" onClick={() => setMenuOpened(false)}>&#61453;</button>

                <ul><nav>
                    {
                        data.sectionsdata.map(section => (
                            <li key={section.id}>
                                <a key={section.id} href={`/#${section.nick}`} onClick={() => setMenuOpened(false)}>
                                    {section.name}
                                </a>
                            </li>
                        ))
                    }
                </nav></ul>


            </motion.div>
                    )}
           </AnimatePresence>

        </>

        )
}

export default HeaderMobile;